//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UsesAuthenticatedUser, UsesDashboardLinks } from '@/mixins'
import { get } from 'vuex-pathify'

export default {
  mixins: [ UsesAuthenticatedUser, UsesDashboardLinks ],
  props: {
    pages: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      opened: false,
    }
  },
  computed: {
    ...get({
      awaitingBookingSession: 'myKintell/awaitingBookingSession',
      activeDashboardTabIndex: 'myKintell/activeDashboardTabIndex'
    }),
    activeDashboardTab () {
      return this.dashboardLinks[this.activeDashboardTabIndex]
    },
    alertCount () {
      return this.authenticatedUser ?? this.authenticatedUser.stats.alerts + (this.authenticatedUser.stats.bookingActive ? 1 : 0)
    },
    styles () {
      return {
        width: '100%',
        transform: `translateX(${this.opened ? 0 : 100}%)`
      }
    },
    discoverLinks () {
      return {
        becomeAnAdvisor: this.authenticatedUser ? (this.authenticatedUserIsLearner ? this.pages.joinNow : false) : this.pages.becomeAnAdvisor,
        pricing: this.pages.pricing,
        faqs: this.pages.faqs,
        articles: this.pages.articles,
      }
    },
    findLinks () {
      return {
        search: this.pages.search,
        browseByCategory: this.pages.browseByCategory,
      }
    },
    hasKintellGroups () {
      return this.kintellGroups?.length || false
    },
    kintellGroups () {
      return this.authenticatedUser?.kintellGroups
    },
  },
  methods: {
    toggleOpen () {
      this.opened = true
    },
    toggleClose (item) {
      this.activeDashboardTab = item
      this.opened = false
    }
  },
}
